export default {"src":"/_next/static/media/wave-01.0350068b.svg","height":700,"width":1920};